import { Response1, Response2 } from "../common/models";
import RomanizationFormatter from "./romanization-formater";
import RowCountOneTable from "./results_tables/row-count-one";
import RowCountTwoTable from "./results_tables/row-count-two";
import { defaultFontSize } from "../common/style-consts";
interface ITranslatingResultsProps {
  data: any | undefined;
}

// const response_for_each_word = {
//   "deutsch": {
//     "word.german,  word.linkon + word.linkontype, word.root"
//   },
//   "arabic": {
//     "word.arabic, word.romanization, "
//   }
// }

const TranslatingResults = (props: ITranslatingResultsProps) => {
  const { data } = props;
  if (!data) {
    return (
      <div style={{ fontSize: defaultFontSize }}>
        Geben Sie bitte Ihre Suchanfrage ein!
      </div>
    );
  }

  if (data[0]?.display_type === "one") {
    return <RowCountOneTable data={data} />;
  } else if (data[0]?.display_type === "two") {
    return <RowCountTwoTable data={data} />;
  } else if (data[0]?.display_type === "not_found") {
    return (
      <div style={{ fontSize: defaultFontSize }}>There is no such word</div>
    )
  } else {
    // Handle other display_type values if needed
    return (
      <div style={{ fontSize: defaultFontSize }}>Unsupported display type</div>
    );
  }
};

export default TranslatingResults;
